module.exports = __webpack_public_path__ + "static/media/path.c957d9d0.svg";